import { LOCAL_STORAGE_COUNTRY_KEY } from "app/context/country.context";
import axios from "axios";
const ClientJS = require('clientjs')

export interface StreamError {
  permalink: string;
  stream?: string;
  error?: string | number;
}

export const sendStreamError = (error: StreamError) => {
  const clientJs = new ClientJS.ClientJS();
  const country = window.localStorage.getItem(LOCAL_STORAGE_COUNTRY_KEY);
  const ip = country ? JSON.parse(country)?.ip : '';

  if (error.stream && error.stream.indexOf('http://') === 0) {
    error.error = 'HTTP';
  }
  try {
    axios({
      method: 'get',
      url: '/api/google-api/playback-error',
      params: {
        data: {
          ...error,
          ip,
          date: new Date(),
          userAgent: clientJs.getUserAgent(),
          fingerprint: clientJs.getFingerprint()
        }
      },
    });
  } catch (e) { }
};

export default sendStreamError;